import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'tether'),
  es: flattenMessages(es, 'tether'),
  ru: flattenMessages(ru, 'tether'),
  zh: flattenMessages(zh, 'tether'),
};
